import { Box } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { visuallyHidden } from "@mui/utils"
import { If } from "lib/@components/switch"

export function NavCountBadge({ count, color = "info", label, sx }) {
    if (!count) return null
    return (
        <Box
            component="span"
            sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: 24,
                height: 24,
                px: 0.75,
                borderRadius: 1,
                fontSize: 14,
                fontWeight: 600,
                lineHeight: 1,
                color: badgeColor,
                bgcolor: badgeBackground,
                ...sx,
            }}
        >
            <Box component="span" aria-hidden="true">
                {count}
            </Box>
            <If value={!!label}>
                <Box component="span" sx={visuallyHidden}>
                    {getPhrase()}
                </Box>
            </If>
        </Box>
    )

    function getPhrase() {
        return ` there ${count === 1 ? "is" : "are"} ${count} ${label}`
    }

    function badgeColor(theme) {
        const palette = theme.palette[color]
        if (theme.palette.mode === "dark") return palette?.lighter ?? theme.palette.text.primary
        return palette?.darker ?? theme.palette.text.primary
    }

    function badgeBackground(theme) {
        const main = theme.palette[color]?.main ?? theme.palette.grey[500]
        return alpha(main, theme.palette.mode === "dark" ? 0.24 : 0.16)
    }
}
